// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"6b888c25e0c9c00de0f0","293":"fa86c80c830da4f72ce2"}[chunkId] + ".js";
};